import { StreamActions } from "@hotwired/turbo"

StreamActions.close_modal = function() {
    const element = document.getElementById(this.target)
    if (element) {
        element.dispatchEvent(new CustomEvent("modal:close"))
    }
}

StreamActions.close_modal2 = function() {
    const modal = document.getElementById(this.target)

    if (modal) {
        const instance = M.Modal.getInstance(modal) // Materialize modal close
        if (instance) {
            instance.close()
            // instance.dispatchEvent(new CustomEvent("modal:close"))
        }
        else {
            alert("No Materialize instance found!")
            // Or if using a custom modal, just remove it
            // modal.remove()
        }
    }
}